module.exports = __webpack_public_path__ + "img/gafas-2.3138aae6.png";